import { connect } from 'react-redux';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {SessionRequired} from '../../../lib/api/components/SessionRequired';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Route, Switch, withRouter} from "react-router-dom";
import Dashboard from "./Dashboard";
import GlobalError from "../../app/components/GlobalError";
import {NoMatch} from "../../app/containers/NoMatch";
import {Helmet} from "react-helmet/es/Helmet";
import { injectIntl, intlShape } from 'react-intl';

@injectIntl
export class Profile extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    }

    render() {
        const { dispatch, session } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.my_account' })} />
                <Page.Header />
                <GlobalError />
                <SessionRequired dispatch={dispatch} session={session}>
                    <Switch>
                        <Route exact path='/profile' component={Dashboard} />
                        <Route component={NoMatch}/>
                    </Switch>
                </SessionRequired>
                <Page.Footer />
            </Page>
        );
    }
}

export default withRouter(connect(state => ({
    session: state.session,
}))(Profile));
